import ApplicationSerializer from 'eflex/serializers/application';

export default class ModelSerializer extends ApplicationSerializer {
  attrs = {
    taskConfigs: {
      serialize: false,
      deserialize: false,
    },
    jemConfigurations: {
      serialize: false,
      deserialize: false,
    },
    productionSchedules: {
      serialize: false,
      deserialize: false,
    },
  };
}
